import React, {useState} from "react";
import cs from "classnames"
import IframePreview from "../atoms/IframePreview";
import Button from "../atoms/Button";
import ViewSwitcher from "../atoms/ViewSwitcher";
import {useApplicationContext} from "../../../../context/ApplicationContext/ApplicationContext";
import {updateEmail} from "../../../../context/ApplicationContext/actions";
import {copyToClipboard} from "../../../../services/utils";
import {event} from "../../../../services/analytics";

export type EmailPreviewProps = {
  className?: string
}

const EmailPreview: React.FC<EmailPreviewProps> = ({className}) => {

  const {state, dispatch} = useApplicationContext()
  const engine = state.configuration.pageConfig.renderEngine

  const [isMobile, setIsMobile] = useState(false)
  return <div className={cs("bg-gray-200 shadow-lg rounded-xl flex flex-col overflow-hidden", className)}>
    <div className={"overflow-hidden flex flex-row-reverse px-4 py-2 items-center bg-white border-b"}>
      <ViewSwitcher classNames={"mx-2"}
        isMobile={isMobile}
        onChange={(input) => {
          event({action: "switch_email_layout_click", params: {}})
          setIsMobile(input)
        }}/>
      <Button className={"mx-2"}
        title={"Refresh"}
        onClick={() => {
          event({action: "refresh_click", params: {}})
          updateEmail(dispatch, state.configuration)
        }}/>
      <Button className={"mx-2"}
        title={"Copy content"}
        onClick={() => {
          event({action: "copy_email_click", params: {}})
          if (state.result.body) {
            copyToClipboard(state.result.body)
          }
        }}/>
    </div>

    <div className={cs(
      isMobile && "w-[360px] mx-auto",
      !isMobile && "min-w-[360px]",
      "pb-6",
      "flex-1 bg-white")}>

      <IframePreview className={cs(
        // engine === "MD" && "px-4",
      )} content={state.result.body}/>

    </div>
  </div>
}
export default EmailPreview;
